exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-8c84c410] {\n  box-sizing: border-box;\n  border-radius: 100%;\n  border: 5px solid transparent;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  -webkit-animation: spinner-animation-data-v-8c84c410 0.6s infinite linear;\n          animation: spinner-animation-data-v-8c84c410 0.6s infinite linear;\n}\n@-webkit-keyframes spinner-animation-data-v-8c84c410 {\n100% {\n    transform: rotate(360deg);\n}\n}\n@keyframes spinner-animation-data-v-8c84c410 {\n100% {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
